module.exports = __webpack_public_path__ + "static/media/coffee-2.29efe9af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/coffee-2.jpg
// module id = 589
// module chunks = 6